var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.getNavigationComponent,{tag:"component",on:{"search":function($event){return _vm.handleSearch($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }